var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.94737 10.4907V8.9118H11.8421V10.4907H3.94737ZM3.94737 6.28022V4.70127H11.8421V6.28022H3.94737ZM1.57895 13.1223H9.47368C9.94193 13.1223 10.3751 13.2236 10.7732 13.426C11.1714 13.6285 11.5095 13.9145 11.7874 14.2842L14.2105 17.4423V2.6568C14.2105 2.56224 14.1802 2.48461 14.1195 2.42391C14.0588 2.36321 13.9811 2.33285 13.8866 2.33285H1.90289C1.80833 2.33285 1.7307 2.36321 1.67 2.42391C1.6093 2.48461 1.57895 2.56224 1.57895 2.6568V13.1223ZM1.90289 19.175H13.5445L10.5445 15.25C10.4122 15.0757 10.2546 14.9407 10.0718 14.845C9.88904 14.7492 9.68965 14.7013 9.47368 14.7013H1.57895V18.851C1.57895 18.9456 1.6093 19.0232 1.67 19.0839C1.7307 19.1446 1.80833 19.175 1.90289 19.175ZM13.8866 20.7539H1.90289C1.37114 20.7539 0.921053 20.5697 0.552632 20.2013C0.184211 19.8329 0 19.3828 0 18.851V2.6568C0 2.12505 0.184211 1.67496 0.552632 1.30654C0.921053 0.938117 1.37114 0.753906 1.90289 0.753906H13.8866C14.4183 0.753906 14.8684 0.938117 15.2368 1.30654C15.6053 1.67496 15.7895 2.12505 15.7895 2.6568V18.851C15.7895 19.3828 15.6053 19.8329 15.2368 20.2013C14.8684 20.5697 14.4183 20.7539 13.8866 20.7539Z",
    fill: "#BE6060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.2733ff323993a7aa73f4af6ff581d86c.svg";
export { ForwardRef as ReactComponent };